import {fetch} from '../../utils/dataAccess';

export default async function updateShipmentAddress(shipmentAddressIri, values) {
    const body = {
        firstname: values.firstname,
        lastname: values.lastname,
        company: values.company,
        address: values.address,
        addressMore: values.addressMore,
        postalCode: values.postalCode,
        city: values.city,
        country: values.country,
        phone: values.phone,
        email: values.email,
    };

    const response = await fetch(
        shipmentAddressIri,
        {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: new Headers({'Content-Type': 'application/merge-patch+json'}),
        },
    );

    return await response.json();
}
